import { useData } from "@hooks/useData";
import { components } from "@apiSchema";
import http from "@core/fetch";
import apiConfig from "@apiConfig";

type AuthorsCategory = components["schemas"]["AuthorsCategoryViewModel"];

export interface IAuthorsCategory {
    id: number;
    name: string;
}

export const FOODIES_CATEGORY_ID = 1;

const REQUEST_TYPE: keyof typeof apiConfig = 'get authors categories';

function mapCategory(category: AuthorsCategory): IAuthorsCategory | null {
    const name = category.name?.trim();
    if (category.id == null || !name) return null;
    return { id: category.id, name };
}

export function mapAuthorsCategories(response: AuthorsCategory[]): IAuthorsCategory[] {
    return (response ?? [])
        .map(mapCategory)
        .filter((category): category is IAuthorsCategory => category !== null);
}

async function getAuthorsCategories(): Promise<IAuthorsCategory[]> {
    try {
        const response: AuthorsCategory[] = await http.get(REQUEST_TYPE);
        return mapAuthorsCategories(response);
    } catch (error) {
        console.error('Fetch error:', REQUEST_TYPE, error);
        return [];
    }
}

export function useAuthorsCategories() {
    return useData<IAuthorsCategory[]>([], getAuthorsCategories);
}
